<!-- Step Templates -->
<ng-template #step0Template>
  <app-registration-step-0-preface [prefaceForm]="prefaceForm">
  </app-registration-step-0-preface>
</ng-template>

<ng-template #step1Template>
  <app-registration-step-1-user
    [userForm]="userForm"
    [userFormFieldLabels]="userFormFieldLabels"
    (autoFillRequested)="onAutoFillRequested()"
  >
  </app-registration-step-1-user>
</ng-template>

<ng-template #step2Template>
  <app-registration-step-2-organisation
    [organisationForm]="organisationForm"
    [organisationFormFieldLabels]="organisationFormFieldLabels"
  >
  </app-registration-step-2-organisation>
</ng-template>

<ng-template #step3Template>
  <app-registration-step-3-verification
    [verificationForm]="verificationForm"
    [verificationFormFieldLabels]="verificationFormFieldLabels"
  >
  </app-registration-step-3-verification>
</ng-template>

<ng-template #step4Template>
  <app-registration-step-4-summary
    [userForm]="userForm"
    [organisationForm]="organisationForm"
    [verificationForm]="verificationForm"
  ></app-registration-step-4-summary>
</ng-template>

<!-- Stepper Component with available templates - inside transloco so t is available -->
<div class="multi-step-form-container" *transloco="let t; prefix: 'registration.page'">
  <!-- Stepper Component with available templates -->
  @if (registrationStepsWithContent.length > 0) {
    <div class="modern-stepper">
      <htx-stepper
        [steps]="registrationStepsWithContent"
        [initialStep]="currentStep()"
        (previous)="onPrevious()"
        (next)="onNext()"
        (lastStep)="onSubmit()"
        [previousLabel]="t('button.previous')"
        [nextLabel]="t('button.next')"
        [lastStepLabel]="t('button.submit')"
        [showDivider]="true"
        [nextDisabled]="!isCurrentStepValid()"
      >
        <ng-container [ngTemplateOutlet]="getStepTemplate()">
        </ng-container>
      </htx-stepper>
    </div>
  }
</div>
